import React, { useState } from "react";
import { Container, Stack, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { colors } from "../../../utils";
import { Input } from "../../../components";
import IyugaDropdown from "../../../components/iyugaDropdown";

// Styled Components
const BannerContainer = styled("div")`
  background-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 54.78%,
      #ffffff 100%
    ),
    linear-gradient(
      0deg,
      rgba(155, 90, 248, 0.6237) 0%,
      rgba(155, 90, 248, 0.4032) 63.27%
    ),
    conic-gradient(
      from 180deg at 50% 50%,
      #f5eede -41.73deg,
      #f7fed5 53.81deg,
      #ccfeff 133.87deg,
      #fdcffe 244.39deg,
      #f5eede 318.27deg,
      #f7fed5 413.81deg
    );
  background-size: cover;
  background-position: center;
  padding-top: 40px;
  padding-bottom: 24px;
  width: 100%;
`;

const ContentContainer = styled(Container)`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled(Typography)`
  color: ${colors.white};
  font-size: 48px;
  font-weight: 400;
  text-align: center;
  font-family: "DM Serif Text", serif;
  line-height: 48.48px;
  letter-spacing: -0.15px;
`;

export const SearchInput = styled(Input)`
  height: 48px;
  width: 28vw;
  border-radius: 5px;
`;

export default function ExploreBanner({
  SearchBarComponent,
  ContentTypeDropdown,
  showSearch = true,
}) {
  const [selected, setSelected] = useState("Wheels");
  return (
    <BannerContainer>
      <ContentContainer maxWidth="xl">
        <Title>
          Elevate the way you <br></br> create, share, and access content
        </Title>
        <Stack
          sx={{ height: "48px" }}
          gap={2}
          my={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          {showSearch && (
            <>
              {SearchBarComponent}
              {/* <ContentTypeDropdown /> */}
            </>
          )}
        </Stack>
      </ContentContainer>
    </BannerContainer>
  );
}
